import PropTypes from 'prop-types'
import clsx from 'clsx'
import ReactTooltip from 'react-tooltip'
import { useTranslation } from 'react-i18next'

import Icon from '../Icon'

import styles from './style.module.scss'

export default function Btn(props) {
	const { t } = useTranslation()
	/*
	 * Die ersten sieben Namen sind historisch und an vielen Stellen im Einsatz;
	 * sie bleiben erhalten. Zwei davon waren irrefuehrend - "grey" ist Teal,
	 * "orange" ist Gruen. Fuer neue Ansichten die sprechenden Namen darunter
	 * verwenden.
	 */
	const themes = {
		download: styles.themeDownload,
		grey: styles.themeGrey,
		orange: styles.themeOrange,
		white: styles.themeWhite,
		minimal: styles.themeMinimal,
		whiteBackground: styles.whiteBackground,
		red: styles.themeRed,

		primary: styles.themePrimary,
		secondary: styles.themeSecondary,
		success: styles.themeSuccess,
		danger: styles.themeDanger
	}

	return (
		<>
			<button
				onClick={props.onClick}
				type={props.type}
				form={props.form}
				disabled={props.loading || props.disabled}
				style={props.width ? { width: props.width } : {}}
				data-tip
				data-for={props.tooltip}
				className={clsx(
					styles.root,
					props.className,
					props.loading && styles.rootLoading,
					props.theme && themes[props.theme],
					// Kompakte Variante fuer Tabellenzeilen mit mehreren Aktionen
					props.size === 'small' && styles.themeSmall,
					// Wartet auf Zutun: orange und leise pulsierend
					props.attention && styles.attention
				)}>
				{props.icon && !props.loading && (
					<Icon
						style={{ order: props.iconOrder }}
						className={clsx(styles.icon, props.iconClassName)}
						size={props.iconSize}
						name={props.icon}
						noFill={props.noFillIcon}
						color={props.iconColor}
					/>
				)}
				{props.loading && (
					<Icon
						style={{ order: props.iconOrder }}
						className={clsx(styles.icon, props.iconClassName)}
						size={props.iconSize || { w: 16, h: 16 }}
						name="loading"
						color={props.iconColor || '#fff'}
					/>
				)}{' '}
				{props.children}
			</button>
			{props.tooltip && (
				<ReactTooltip id={props.tooltip} place="top">
					<span>{t(props.tooltip)}</span>
				</ReactTooltip>
			)}
		</>
	)
}

Btn.propTypes = {
	size: PropTypes.oneOf(['small']),
	className: PropTypes.string,
	tooltip: PropTypes.string,
	width: PropTypes.number,
	type: PropTypes.string,
	/*
	 * Kennung des Formulars, das dieser Knopf absendet (HTML-Attribut `form`).
	 * Erlaubt einen Absenden-Knopf ausserhalb seines Formulars: Im Fenster einer
	 * Mitarbeiter:in stehen "Speichern" und "Loeschen" in einer gemeinsamen
	 * Fussleiste, das Formular darueber.
	 */
	form: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	icon: PropTypes.string,
	iconClassName: PropTypes.string,
	iconColor: PropTypes.string,
	iconSize: PropTypes.shape({
		w: PropTypes.number.isRequired,
		h: PropTypes.number.isRequired
	}),
	iconOrder: PropTypes.number,
	loading: PropTypes.bool,
	disabled: PropTypes.bool,
	/*
	 * Hebt die Schaltflaeche hervor, solange sie auf Zutun wartet: orange und
	 * leise pulsierend, z. B. "Speichern" bei ungespeicherten Aenderungen.
	 */
	attention: PropTypes.bool,

	theme: PropTypes.string,
	onClick: PropTypes.func,
	noFillIcon: PropTypes.bool
}

Btn.defaultProps = {
	tooltip: '',
	type: 'button',
	className: '',
	loading: false,
	disabled: false,
	attention: false,
	iconOrder: 1,
	noFillIcon: false,
	children: [],
	onClick: () => {} // TODO REMOVE
}
